module.exports = __webpack_public_path__ + "img/catalogue-banner.31742f8a.jpg";